var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSh1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 15,
    cy: 15,
    r: 15,
    fill: "url(#paint0_linear_816_78714)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7961 22.4352C14.8792 22.4786 14.972 22.5007 15.0649 22.5C15.1578 22.4992 15.2499 22.4764 15.3337 22.4323L18.0096 21.0018C18.7684 20.5973 19.3627 20.145 19.8263 19.6185C20.8343 18.4712 21.3847 17.0069 21.3749 15.497L21.3432 10.5165C21.3401 9.94283 20.9634 9.43096 20.4061 9.24489L15.4281 7.57467C15.1283 7.47318 14.7999 7.47539 14.5054 7.57982L9.54621 9.30961C8.992 9.50303 8.62202 10.0186 8.62504 10.593L8.65675 15.5698C8.66657 17.0819 9.23588 18.5395 10.2605 19.6751C10.7286 20.1943 11.3281 20.64 12.0953 21.0379L14.7961 22.4352ZM14.0877 16.5817C14.1994 16.6891 14.3444 16.742 14.4894 16.7406C14.6344 16.7398 14.7786 16.6854 14.8888 16.5765L17.8131 13.6936C18.0329 13.4766 18.0306 13.128 17.8086 12.914C17.5859 12.7 17.2272 12.7014 17.0075 12.9184L14.4811 15.4086L13.4467 14.4143C13.2239 14.2003 12.866 14.2025 12.6455 14.4195C12.4258 14.6364 12.4281 14.985 12.6508 15.199L14.0877 16.5817Z",
    fill: "url(#paint1_linear_816_78714)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_816_78714",
    x1: 0,
    y1: 0,
    x2: 30.599,
    y2: 0.813926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_816_78714",
    x1: 8.625,
    y1: 7.5,
    x2: 21.6321,
    y2: 7.79409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91E5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSh1);
export default __webpack_public_path__ + "static/media/sh1.a7961d2170f1a6bcd966fd5155bb068d.svg";
export { ForwardRef as ReactComponent };